export default __webpack_public_path__ + "static/media/brand-02.7c6149d6.jpg";